import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

import { GLOBAL_MESSAGES } from '../@core/entities/constants';
import { AuthService, SessionStorageService } from '../@core/services';
import { AlertService } from '../@core/services/alert.service';
import { UserLogin } from './_entity/userLogin.data.model';
import { ProjectUserInfo, AppUser } from '../@core/entities/authDataModel';
import { BehaviorSubject } from 'rxjs';
declare var $: any;
@Component({
  // moduleId: module.id,
  // tslint:disable-next-line:component-selector
  selector: 'login',
  styleUrls: ['./login.component.scss'],
  templateUrl: 'login.component.html'
})
export class LoginComponent implements OnInit {
  private currentUserSubject = new BehaviorSubject<AppUser>({} as AppUser);
  loginForm: FormGroup;
  show = false;
  projectdata = 0;
  projId: number;
  projectlist: ProjectUserInfo[];
  userRole: AppUser;
  @ViewChild('showhideinput') input;
  // tslint:disable-next-line:max-line-length
  constructor(private _alertService: AlertService, private storage: SessionStorageService, private _authService: AuthService, private formBuilder: FormBuilder, private _route: Router) { }

  ngOnInit() {
    this.formIntilize();
  }
  formIntilize() {
    this.loginForm = this.formBuilder.group({
      userName: [''],
      password: ['']
    });
  }
  login(loginval: UserLogin) {
    if (loginval.userName && loginval.password) {
      this._authService.login(loginval.userName, loginval.password).subscribe(
        (response) => {
          if (response && response.userRoles) {            
            if (response.userRoles[0].name !== 'ADM' && response.userRoles[0].name !== 'SAM') {
              this._authService.getProjectList().subscribe((res) => {
                this.projectlist = res;
                this.storage.setObj('projectval', this.projectlist[0]);
                if (this.projectlist.length !== 1) {
                  $('#change-project').modal('show');
                } else {
                  this._authService.roleBasedRoute(response.userRoles[0].name);
                }
              });
            } 
            else  if (response.userRoles[0].name === 'SAM') {
              this.storage.setObj('projectval', response.projectUserInfo);
              this._authService.roleBasedRoute(response.userRoles[0].name);
            }
            
            else {
              this.storage.setObj('projectval', response.projectUserInfo);
              this._authService.roleBasedRoute(response.userRoles[0].name);
            }

            this.storage.setObj('userrole', response.userRoles[0].name);
            

          } else if (response.result === 'failed') {
            this._alertService.error('Invalid credentials/Access denied');
          } else {
            this._alertService.error('User roles are not mapped for this user to access this application. Please contact your site admin.');
          }
        },
        (error) => {
          this._alertService.error(GLOBAL_MESSAGES.ERROR_MESSAGE);
        }
      );
    } else {
      this._alertService.warn('Email or password should not be empty!');
    }
  }

  toggleShow() {
    this.show = !this.show;
    if (this.show) {
      this.input.nativeElement.type = 'text';
    } else {
      this.input.nativeElement.type = 'password';
    }
  }

  changeproj(data) {
    this.projId = Number(data);
  }

  saveproject() {
    this.userRole = this._authService.getCurrentUser();
    if (this.projId !== 0) {
      this.projectlist.map(item => {
        if (item.projectId === this.projId) {
          this.userRole.projectUserInfo = item;
          this.storage.setObj('projectval', this.userRole.projectUserInfo);
          this.currentUserSubject.next(this.userRole);
        }
      });
      $('#change-project').modal('hide');
      this._authService.roleBasedRoute(this.userRole.userRoles[0].name);
    }
  }
  privacypolicy() {
    this._route.navigate(['/terms-codition']);
  }
}
